import { IGetMetricDataPointsByIdsParams } from '../types/IGetMetricDataPointsByIdsParams';
import { IMetricDataList } from '../types/IMetricDataList';
import { Request, RequestHeaders } from './Request';

export type GetMetricDataPointsByIdsParams = IGetMetricDataPointsByIdsParams;

export class GetMetricDataPointsByIdsRequest extends Request<GetMetricDataPointsByIdsParams, IMetricDataList> {
  constructor(params: GetMetricDataPointsByIdsParams, headers?: RequestHeaders) {
    super('getMetricDataPointsByIds', params, headers);
  }
}
